import { useState as m, useEffect as e } from "react";
import { useIsMounted as g } from "./index4.js";
const l = (t) => {
  const [r, o] = m(t), u = g();
  return e(() => {
    o(t);
  }, t), u ? r.length !== t.length || r.some((s, f) => s !== t[f]) : !0;
};
export {
  l as useDidChange
};
//# sourceMappingURL=index.js.map
